import { authorizedInstance } from "../config/axios"

export const illustrationResult = async ({ page, limit, sortBy, filters }) => {
  const query = new URLSearchParams({
    page,
    limit,
    sortBy,
    ...filters,
  })

  const response = await authorizedInstance.get(`illustration-results?${query}`)
  return response.data
}

export const illustrationUsageReport = async ({
  page,
  limit,
  sortBy,
  filters,
}) => {
  const query = new URLSearchParams({
    page,
    limit,
    sortBy,
    ...filters,
  })

  const response = await authorizedInstance.get(
    `illustration-results/usage-report?${query}`
  )
  return response.data
}
